<template>
  <vf-button
    :class="brandClasses?.button"
    :size
    :variant
    @click="emit('click')"
  >
    <vf-icon v-if="showIcon" :class="brandClasses?.icon" name="location" size="md" />
    {{ $t.findInStore }}
  </vf-button>
</template>

<script lang="ts" setup>
const emit = defineEmits<{
  click: []
}>()

const { brandClasses, size, showIcon, variant } = useAppConfig().components.product.cta?.findInStore || {}
</script>
